<script>
import AccidentIncidentEventChart from "@/components/dashboard/accident-incident/AccidentIncidentEventChart.vue";
import InvestigationEventChart from "@/components/dashboard/investigation/InvestigationEventChart.vue";
import {mapActions, mapGetters} from "vuex";
import {AccidentIncidentDashboardService} from "@/services/AccidentIncidentDashboardService";
import AccidentIncidentYearlyTable from "@/components/dashboard/accident-incident/AccidentIncidentYearlyTable";
import AppLoading from "@/components/elements/AppLoading";
export default {
  name: "InvestigationDashboard",
  components: {
    InvestigationEventChart,
    'ai-yearly-table': AccidentIncidentYearlyTable, AccidentIncidentEventChart,'app-loading' : AppLoading},
  data(){
    return{
      event: {
        event_one_id: null,
        event_two_id: null,
        event_three_id: null,
        event_four_id: null,
      },
      imm_causes: {
        event_one_id: null,
        event_two_id: null,
        event_three_id: null,
        event_four_id: null,
        sub_act_id: null,
        sub_con_id: null,
      },
      root_causes: {
        event_one_id: null,
        event_two_id: null,
        event_three_id: null,
        event_four_id: null,
        rc_cause_id: null,
        rc_factor_id: null,
      },
      aiChartData: [],
      aiImmCauseChartData: [],
      aiRootCauseChartData: [],
      startYear:new Date().toISOString().split("T")[0].split('-')[0] - 5,
      currentYear:new Date().toISOString().split("T")[0].split('-')[0],
      office_id: null,
      loading: false,
      loadingChart: false,
      immediateActsMain: {},
      immediateActsSub: {},
      immediateConditionsMain: {},
      immediateConditionsSub: {},
      basicCauseMain: {},
      basicCauseSub: {},
      cause:{},
      showImmediateCause: false,
      showRootCause: false,
    }
  },
  methods:{
    ...mapActions(['getAccidentCharts','getMngmtOfficeKeys', 'getEventOneKeys', 'getEventTwoKeys', 'getEventThreeKeys', 'getEventFourKeys', 'getEventFiveKeys', 'getMainCauseKeys', 'getSubCauseKeys']),

    showCause(cause){
      if (cause === 'immCause') {
          this.$nextTick(() => {
            this.$refs.immediateCause?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          });
      }

      if (cause === 'rootCause') {
          this.$nextTick(() => {
            this.$refs.rootCause?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          });
      }
    },

    modifyEventCode(key = '', evt) {
      switch (key){
        case 'event.event_one_id':
          this.event.event_one_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_two_id = null
          this.event.event_three_id = null
          this.event.event_four_id = null
          this.event.event_five_id = null
          this.getEventTwoKeys({event_one_id: this.event.event_one_id})
          break;

        case 'event.event_two_id' :
          this.event.event_two_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_three_id = null
          this.event.event_four_id = null
          this.event.event_five_id = null
          this.getEventThreeKeys({event_one_id: this.event.event_one_id, event_two_id: this.event.event_two_id})
          break;

        case 'event.event_three_id':
          this.event.event_three_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_four_id = null
          this.event.event_five_id = null
          this.getEventFourKeys({
            event_one_id: this.event.event_one_id,
            event_two_id: this.event.event_two_id,
            event_three_id: this.event.event_three_id
          })
          if (this.event.event_three_id === 50 || this.eventFourKeys.length > 0) {
            this.getEventFiveKeys({
              event_one_id: this.event.event_one_id,
              event_two_id: this.event.event_two_id,
              event_three_id: this.event.event_three_id
            })
            this.event.event_four_id = null;
          }
          break;
        case 'event.event_four_id':
          this.event.event_four_id = evt.target.value === '' ? null : evt.target.value;
          this.event.event_five_id = null
          this.getEventFiveKeys({ event_one_id: this.event.event_one_id, event_two_id: this.event.event_two_id, event_three_id: this.event.event_three_id })
          break;
      }

      this.generateChart();
    },

    async getImmediateActsMain() {
      const params = {
        cause_type_id: 2,
        cause_type_class_id: 1
      }
      await this.getMainCauseKeys(params)
      this.immediateActsMain = this.mainCauseKeys
    },

    async getImmediateConsMain() {
      const params = {
        cause_type_id: 2,
        cause_type_class_id: 2
      }
      await this.getMainCauseKeys(params)
      this.immediateConditionsMain = this.mainCauseKeys
    },

    async getBasicCauseMain(){
      const params = {
        cause_type_id: 1,
        cause_type_class_id: 0
      }
      await this.getMainCauseKeys(params)
      this.basicCauseMain = this.mainCauseKeys
    },

    async generateChart(){
      this.loadingChart = true;
      if(this.$route.params.chart_module === 'immediate_cause'){
        this.imm_causes.office_id = this.office_id;
        this.imm_causes.event_one_id = this.event.event_one_id;
        this.imm_causes.event_two_id = this.event.event_two_id;
        this.imm_causes.event_three_id = this.event.event_three_id;
        this.imm_causes.event_four_id = this.event.event_four_id;
        const response = await AccidentIncidentDashboardService.getAccidentIncidentChartData(this.imm_causes);
        this.aiChartData = response.data;
      }
      else if(this.$route.params.chart_module === 'root_cause'){
        this.root_causes.office_id = this.office_id;
        this.root_causes.event_one_id = this.event.event_one_id;
        this.root_causes.event_two_id = this.event.event_two_id;
        this.root_causes.event_three_id = this.event.event_three_id;
        this.root_causes.event_four_id = this.event.event_four_id;
        const response = await AccidentIncidentDashboardService.getAccidentIncidentChartData(this.root_causes);
        this.aiChartData = response.data;
      }
      else{
        this.event.office_id = this.office_id;
        const response = await AccidentIncidentDashboardService.getAccidentIncidentChartData(this.event);
        this.aiChartData = response.data;
      }

      const responseImm = await AccidentIncidentDashboardService.getAccidentIncidentImmediateCauseChartData(this.event);
      const responseRoot = await AccidentIncidentDashboardService.getAccidentIncidentRootCauseChartData(this.event);
      this.aiImmCauseChartData = responseImm.data;
      this.aiRootCauseChartData = responseRoot.data;
      this.loadingChart = false;
    },
    async clearChartFilters(){
      this.event.event_one_id = null;
      this.event.event_two_id = null;
      this.event.event_three_id = null;
      this.event.event_four_id = null;
      this.event.office_id = null;
      this.imm_causes.sub_act_id = null;
      this.imm_causes.sub_con_id = null;
      this.root_causes.rc_cause_id = null;
      this.root_causes.rc_factor_id = null;
      this.office_id = null;
      await this.generateChart();
    },
    async getCauses(){
      await this.generateChart();
      if(this.$route.params.chart_module === 'immediate_cause'){
        await this.getImmediateActsMain();
        await this.getImmediateConsMain();
      }
      if(this.$route.params.chart_module === 'root_cause'){
        await this.getBasicCauseMain();
      }
    },
  },
  computed:{
    ...mapGetters(['airChartCounts','mngmntOfficeKeys','user','eventOneKeys', 'eventTwoKeys', 'eventThreeKeys', 'eventFourKeys', 'eventFiveKeys','mainCauseKeys','subCauseKeys']),

    selectedEventOne() {
      return this.eventOneKeys.find(
        event => event.id == this.event.event_one_id
      ) || null;
    },

    years(){
      let years=[];
      for (var i = this.startYear; i <= this.currentYear; i++) {
        years.push(i);
      }
      return years;
    },
  },
  watch: {
    'root_causes.rc_cause_id': async function() {
      const params = {
        main_cause_id: this.root_causes.rc_cause_id
      }
      await this.getSubCauseKeys(params)
      this.basicCauseSub = this.subCauseKeys
    },
  },
  async created() {
    this.getMngmtOfficeKeys({dashboard:true});
    await this.getEventOneKeys();
    await this.generateChart();
    if(this.$route.params.chart_module === 'immediate_cause' || this.$route.params.chart_module === 'root_cause'){
      await this.getCauses();
    }
  },
}
</script>
<template>
<div class="container-fluid px-4">
  <div class="row">
    <div class="col-sm-12 col-md-8 col-lg-8">
      <span class="h2 e-text-red text-uppercase font-weight-bold">Investigation</span>
    </div>
    <div class="col-sm-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center">
      <select name="" id="" class="form-control form-control-sm" v-model="office_id" @change="generateChart">
        <option :value="null">SELECT BRANCH OFFICE</option>
        <option :value="office.id" v-for="office in mngmntOfficeKeys ">
          {{office.name ? office.name.toUpperCase() : ''}}
        </option>
      </select>
    </div>
  </div>
  <hr style="border-top: 3px solid #e1e1e1">
<!--  NAVIGATIONS-->
  <div class="row">
    <div class="col-auto">
      <nav class="navbar navbar-expand-lg mt-2" id="ModelNav">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
                aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item" @click="getCauses">
              <router-link
                class="nav-link" :to="{ name: 'InvestigationDashboard', params : {
                  chart_module : 'number_of_report'
                }}">
                <span style="height: 100%">Number of Reports</span>
              </router-link>
            </li>
<!--            <li class="nav-item" @click="getCauses">-->
<!--              <router-link-->
<!--                class="nav-link" :to="{ name: 'InvestigationDashboard', params : {-->
<!--                  chart_module : 'immediate_cause'-->
<!--                }}">-->
<!--                <span style="height: 100%">Immediate Cause</span>-->
<!--              </router-link>-->
<!--            </li>-->
<!--            <li class="nav-item" @click="getCauses">-->
<!--              <router-link-->
<!--                class="nav-link" :to="{ name: 'InvestigationDashboard', params : {-->
<!--                  chart_module : 'root_cause'-->
<!--                }}">-->
<!--                <span style="height: 100%">Root Cause</span>-->
<!--              </router-link>-->
<!--            </li>-->
          </ul>
        </div>
      </nav>
    </div>
  </div>
<!--  FILTERS-->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body mb-0 pb-1">
          <div class="row">
            <div class="col-6 mt-1">
              <span class="h6 text-black text-uppercase font-weight-bold">Filters:</span>
            </div>
            <div class="col-6 text-right">
<!--              <button class="e-btn e-btn-blue-gray text-uppercase font-weight-bold" v-if="loadingChart" style="cursor: not-allowed">Generate Graph</button>-->
<!--              <button class="e-btn e-btn-green text-uppercase font-weight-bold" @click="generateChart" v-else>Generate Graph</button>-->
              <button class="e-btn e-btn-blue-gray text-uppercase font-weight-bold ml-2" @click="clearChartFilters">Clear Filters</button>
            </div>
          </div>

          <hr>
          <div class="row">
            <div class="col-12">
              <div class="row" v-if="$route.params.chart_module === 'number_of_report'">
                <div class="col-12 mb-2">
                  <small class="pb-2 pt-2 font-weight-bold text-uppercase" style="color: #d3313c; font-style: italic; font-size: 9pt;">
                    Event Type:
                  </small>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_one_id',$event)"
                          v-model="event.event_one_id"
                          :disabled="loadingChart">
                    <option :value="null" disabled>-- Select Event Code 1 --</option>
                    <option v-for="event in eventOneKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_two_id',$event)"
                          v-model="event.event_two_id"
                          :disabled="!event.event_one_id || loadingChart">
                    <option :value="null" disabled>-- Select Event Code 2 --</option>
                    <option v-for="event in eventTwoKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_three_id',$event)"
                          v-model="event.event_three_id"
                          :disabled="!event.event_two_id || loadingChart">
                    <option :value="null" disabled>-- Select Event Code 3 --</option>
                    <option v-for="event in eventThreeKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-3">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_four_id',$event)"
                          v-model="event.event_four_id"
                          :disabled="!event.event_three_id || loadingChart">
                    <option :value="null" disabled>-- Select Event Code 4 --</option>
                    <option v-for="event in eventFourKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" v-if="$route.params.chart_module === 'immediate_cause'">
                <div class="col-12 mb-2">
                  <small class="pb-2 pt-2 font-weight-bold text-uppercase" style="color: #d3313c; font-style: italic; font-size: 9pt;">
                    Event Type:
                  </small>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_one_id',$event)"
                          v-model="event.event_one_id">
                    <option :value="null" disabled>-- Select Event Code 1 --</option>
                    <option v-for="event in eventOneKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_two_id',$event)"
                          v-model="event.event_two_id"
                          :disabled="!event.event_one_id">
                    <option :value="null" disabled>-- Select Event Code 2 --</option>
                    <option v-for="event in eventTwoKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_three_id',$event)"
                          v-model="event.event_three_id"
                          :disabled="!event.event_two_id">
                    <option :value="null" disabled>-- Select Event Code 3 --</option>
                    <option v-for="event in eventThreeKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>

                <div class="col-12 pb-3">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_four_id',$event)"
                          v-model="event.event_four_id"
                          :disabled="!event.event_three_id">
                    <option :value="null" disabled>-- Select Event Code 4 --</option>
                    <option v-for="event in eventFourKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 text-center pt-1 pb-1">
                  <div class="divider">
                    <span class="font-weight-bold text-uppercase" style="color: black; font-style: italic; font-size: 9pt;">Causes Attributable to the selected Accident Type</span>
                  </div>
                </div>
                <div class="col-12 mb-2">
                  <small class="pb-2 pt-2 font-weight-bold text-uppercase" style="color: #d3313c; font-style: italic; font-size: 9pt;">
                    Immediate Cause:
                  </small>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          v-model="imm_causes.sub_act_id">
                    <option :value="null" disabled>-- Select Substandard Act --</option>
                    <option v-for="data in immediateActsMain" :key="data.id" :value="data.id">
                      {{data.series}}.) {{data.name}}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-3">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          v-model="imm_causes.sub_con_id">
                    <option :value="null" disabled>-- Select Substandard Condition --</option>
                    <option v-for="data in immediateConditionsMain" :key="data.id" :value="data.id">
                      {{data.series}}.) {{data.name}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" v-if="$route.params.chart_module === 'root_cause'">
                <div class="col-12 mb-2">
                  <small class="pb-2 pt-2 font-weight-bold text-uppercase" style="color: #d3313c; font-style: italic; font-size: 9pt;">
                    Event Type:
                  </small>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_one_id',$event)"
                          v-model="event.event_one_id">
                    <option :value="null" disabled>-- Select Event Code 1 --</option>
                    <option v-for="event in eventOneKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_two_id',$event)"
                          v-model="event.event_two_id"
                          :disabled="!event.event_one_id">
                    <option :value="null" disabled>-- Select Event Code 2 --</option>
                    <option v-for="event in eventTwoKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_three_id',$event)"
                          v-model="event.event_three_id"
                          :disabled="!event.event_two_id">
                    <option :value="null" disabled>-- Select Event Code 3 --</option>
                    <option v-for="event in eventThreeKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>

                <div class="col-12 pb-3">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          @change="modifyEventCode('event.event_four_id',$event)"
                          v-model="event.event_four_id"
                          :disabled="!event.event_three_id">
                    <option :value="null" disabled>-- Select Event Code 4 --</option>
                    <option v-for="event in eventFourKeys" :key="event.id" :value="event.id">
                      {{event.code}}) {{ event.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 text-center pt-1 pb-1">
                  <div class="divider">
                    <span class="font-weight-bold text-uppercase" style="color: black; font-style: italic; font-size: 9pt;">Causes Attributable to the selected Accident Type</span>
                  </div>
                </div>
                <div class="col-12 mb-2">
                  <small class="pb-2 pt-2 font-weight-bold text-uppercase" style="color: #d3313c; font-style: italic; font-size: 9pt;">
                    Root Cause:
                  </small>
                </div>
                <div class="col-12 pb-1">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          v-model="root_causes.rc_cause_id">
                    <option :value="null" disabled>-- Select Root Cause --</option>
                    <option v-for="data in basicCauseMain" :key="data.id" :value="data.id">
                      {{data.series}}.) {{data.name}}
                    </option>
                  </select>
                </div>
                <div class="col-12 pb-3">
                  <select style="font-size: 9pt;" name="" id="" class="form-control form-control-sm text-uppercase"
                          v-model="root_causes.rc_factor_id"
                          :disabled="!root_causes.rc_cause_id">
                    <option :value="null" disabled>-- Select Sub Factor --</option>
                    <option v-for="data in basicCauseSub" :key="data.id" :value="data.id">
                      {{data.series}}.) {{data.name}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
<!--            <div class="col-2 pl-0">-->
<!--              <div class="row pt-3 mt-3">-->
<!--                <div class="col-12">-->
<!--                  <button class="e-btn e-btn-blue-gray text-uppercase font-weight-bold w-100 p-2" v-if="loadingChart" style="cursor: not-allowed">Generate <br>Graph</button>-->
<!--                  <button class="e-btn e-btn-green text-uppercase font-weight-bold w-100 p-2" @click="generateChart" v-else>Generate <br>Graph</button>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="row" :class="{'pt-4 mt-4': $route.params.chart_module !== 'number_of_report','mt-3': $route.params.chart_module === 'number_of_report'}">-->
<!--                <div class="col-12">-->
<!--                  <button class="e-btn e-btn-blue-gray text-uppercase font-weight-bold w-100 p-2" @click="clearChartFilters">Clear <br>Filters</button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
<!--  ACCIDENT / INCIDENT DATA (CHART)-->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-3">
          <div v-if="loadingChart">
            <app-loading></app-loading>
          </div>
          <div v-else>
            <template v-if="$route.params.chart_module === 'number_of_report'">
              <div class="px-1">
                <div class="row">
                  <div class="col-6 mt-1">
                    <span class="h6 e-text-red text-uppercase font-weight-bold">Reports</span>
                    <span class="h6 e-text-blue text-uppercase font-weight-bold" v-if="this.selectedEventOne"> ({{ this.selectedEventOne.code }}. {{ this.selectedEventOne.name }})</span>
                  </div>
                  <div class="col-6 text-right">
                    <button class="e-btn e-btn-blue text-uppercase font-weight-bold" @click="showCause('immCause')">Immediate Cause</button>
                    <button class="e-btn e-btn-blue text-uppercase font-weight-bold ml-2" @click="showCause('rootCause')">Root Cause</button>
                  </div>
                </div>
                <hr>
              </div>
              <InvestigationEventChart
                :data="aiChartData"
                :events-filter="event"
                :years="years"
                :office="office_id"
                chart_id="number_of_report"
              ></InvestigationEventChart>
            </template>
            <template v-if="$route.params.chart_module === 'immediate_cause'">
              <InvestigationEventChart
                :data="aiChartData"
                :events-filter="imm_causes"
                :years="years"
                :office="office_id"
                chart_id="immediate_cause"
              ></InvestigationEventChart>
            </template>
            <template v-if="$route.params.chart_module === 'root_cause'">
              <InvestigationEventChart
                :data="aiChartData"
                :events-filter="root_causes"
                :years="years"
                :office="office_id"
                chart_id="root_cause"
              ></InvestigationEventChart>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--  ACCIDENT / INCIDENT DATA IMMEDIATE CAUSE (CHART)-->
  <div class="row mt-3" id="immediate-cause-section" v-if="$route.params.chart_module === 'number_of_report'" ref="immediateCause">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-3">
          <div v-if="loadingChart">
            <app-loading></app-loading>
          </div>
          <div v-else>
            <div class="px-1">
              <div class="row">
                <div class="col-12 mt-1">
                  <span class="h6 e-text-red text-uppercase font-weight-bold">Immediate Cause Reports</span>
                </div>
              </div>
              <hr>
            </div>
            <InvestigationEventChart
              :data="aiImmCauseChartData"
              :events-filter="event"
              :years="years"
              :office="office_id"
              chart_id="ai_imm_cause"
            ></InvestigationEventChart>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3" id="root-cause-section" v-if="$route.params.chart_module === 'number_of_report'" ref="rootCause">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-3">
          <div v-if="loadingChart">
            <app-loading></app-loading>
          </div>
          <div v-else>
            <div class="px-1">
              <div class="row">
                <div class="col-12 mt-1">
                  <span class="h6 e-text-red text-uppercase font-weight-bold">Root Cause Reports</span>
                </div>
              </div>
              <hr>
            </div>
            <InvestigationEventChart
              :data="aiRootCauseChartData"
              :events-filter="event"
              :years="years"
              :office="office_id"
              chart_id="ai_root_cause"
            ></InvestigationEventChart>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  ACCIDENT / INCIDENT DATA (TABLE)-->
  <div class="row mt-3 mb-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body mb-0 pb-3">
          <div v-if="loadingChart">
            <app-loading></app-loading>
          </div>
          <div v-else>
            <span class="h6 e-text-red text-uppercase font-weight-bold">Accident / Incident Data</span>
            <hr>
            <ai-yearly-table :data="aiChartData" :years="years"></ai-yearly-table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<style scoped>
.text-black{
  color: black;
}
#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 2rem;
    color: #435464;
    height: 100%;
    text-align: center;
  }

  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }
  .nav-link span {
    font-size: 14px;
  }
}

.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
  font-weight: bold;

  * {
    color: #d3313c;
  }
}
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #555;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 2px solid #ccc;
}

.divider:not(:empty)::before {
  margin-right: 0.75em;
}

.divider:not(:empty)::after {
  margin-left: 0.75em;
}

#immediate-cause-section {
  scroll-margin-top: 80px;
}

#root-cause-section {
  scroll-margin-top: 80px;
}

</style>

